"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableEntityRepo = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
class ObservableEntityRepo extends ObservableEntity_1.ObservableEntity {
    constructor() {
        super(...arguments);
        this.entityLookup = new Map();
        this.has = (id) => {
            return this.entityLookup.has(id);
        };
        this.add = (id, entity) => {
            const existing = this.entityLookup.get(id);
            if (existing) {
                existing.removeObserver(this.notify);
            }
            this.entityLookup.set(id, entity);
            entity.addObserver(this.notify);
            this.notify();
        };
        this.remove = (id) => {
            const existing = this.entityLookup.get(id);
            if (!existing)
                return;
            this.entityLookup.delete(id);
            existing.removeObserver(this.notify);
            this.notify();
        };
        this.clear = () => {
            if (this.entityLookup.size === 0)
                return;
            this.entityLookup.forEach((entity) => {
                entity.removeObserver(this.notify);
            });
            this.entityLookup.clear();
            this.notify();
        };
        this.get = (id) => {
            return this.entityLookup.get(id);
        };
        this.getAll = () => {
            return Array.from(this.entityLookup.values());
        };
        this.set = (entities) => {
            if (this.entityLookup.size === 0 && entities.length === 0) {
                return;
            }
            this.entityLookup.forEach((entity) => {
                entity.removeObserver(this.notify);
            });
            this.entityLookup.clear();
            entities.forEach((e) => {
                this.entityLookup.set(e.id, e.entity);
                e.entity.addObserver(this.notify);
            });
            this.notify();
        };
    }
}
exports.ObservableEntityRepo = ObservableEntityRepo;
